module.exports = __webpack_public_path__ + "static/img/btor115dw.1edb7f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/btor115dw.jpg
// module id = 5xmd
// module chunks = 0